import CacheEnabledApiClient from './CacheEnabledApiClient';

class ConcurrentLabelsAPI extends CacheEnabledApiClient {
  constructor() {
    super('concurrent_labels', { accountScoped: true });
  }

  get cacheModelName() {
    return 'concurrent_label';
  }
}

export default new ConcurrentLabelsAPI();

